export enum POIType {
  Structure = 'Structure',
  Location = 'Location',
  RoadWorks = 'RoadWorks',
}
